class DivisionIdentities {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/division-identities`;

  }

  async getDivisionIdentities() {

    const path = this.basePath;

    return this.apiClient.get(path, {}, {});

  }

  async createDivisionIdentity(divisionIdentity) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, divisionIdentity);

  }

  async updateDivisionIdentityById(divisionIdentityId, divisionIdentity) {

    const path = `${this.basePath}/:divisionIdentityId`;

    return this.apiClient.put(path, { divisionIdentityId }, {}, divisionIdentity);

  }

  async deleteDivisionIdentityById(divisionIdentityId) {

    const path = `${this.basePath}/:divisionIdentityId`;

    return this.apiClient.delete(path, { divisionIdentityId }, {});

  }

}

export default DivisionIdentities;